import { SSE } from "../../common/apiUrl/sse/sseUrl";
import { API } from "../../common/model/objectTypes";
import { composeMessageInfo } from "../../utils/apiDescription/sse/composeMessage";
import { API_BASE_URL } from "../../utils/constants";
import { commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { sendMessageRequestBody } from "../../utils/sse/apiObjects";
import { sendMessageJsonRequestCurl } from "../../utils/sse/sampleJsonRequest";

const sendMessage : API = {
    name: "Send Message",
    url: `${API_BASE_URL}/${SSE.COMPOSE_MESSAGE.sendMessage}`,
    method: "POST",
    headers: requestHeaderWithCallback,
    apiInfo: composeMessageInfo.sendMessage,
    requestBody: sendMessageRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: sendMessageJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Send Message':
            return sendMessage;
    }
};